import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const DownlinesApi = {
  fetchDownlines: async (user_id, level = null) => {
    try {
      const params = level !== null ? { user_id, level } : { user_id };
      const url = Configs.myDownlinesEp;

      const response = await axiosInstance.get(url, { params });

      const { status, data, downlines_beyond_level_4 } = response.data;

      if (status === "success") {
        return {
          status: "success",
          downlines: Array.isArray(data) ? data : [],
          downlinesBeyondLevel4: Array.isArray(downlines_beyond_level_4)
            ? downlines_beyond_level_4
            : [],
        };
      } else {
        const message =
          typeof data === "object" ? JSON.stringify(data) : String(data);
        throw new Error(`Failed to fetch downlines: ${message}`);
      }
    } catch (error) {
      return {
        status: "fail",
        message: error.message || "Unknown error occurred.",
      };
    }
  },
};

export default DownlinesApi;
